import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";

import { Form, Modal, Typography, Tabs, TabPane } from "@douyinfe/semi-ui";
import { formatFloat, formatDate } from "../../utils";
import React, { useState, useEffect } from "react";
import LeadReportItem from "./leadReportItem";
import { LeadReportItemProps } from "./leadReportItem";
import {IconUserGroup, IconUser, IconModalStroked} from "@douyinfe/semi-icons";

const apiClient = ApiClient.getDefault();
export default function OrgUserStarStat() {
  const [crudApiUser, setCrudApiUser] = useState(
    undefined as undefined | CrudApi
  );
  const [showLeadItemModalUser, setShowLeadItemModalUser] = useState(false);
  const [leadReportItemPropsUser, setLeadReportItemPropsUser] = useState(
    undefined as undefined | LeadReportItemProps
  );

  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");

  let colsUser: Col[] = [
    {
      name: "姓名",
      width: 150,
      showInFilter: false,
      key: "name",
      type: ColType.STRING,
      render: (value, record, index) => {
        if (record.type == "org") {
          return (
            <Typography.Text strong type="warning">
              {value}
            </Typography.Text>
          );
        } else {
          return <Typography.Text strong>{value}</Typography.Text>;
        }
      },
    },
    {
      name: "城市",
      width: 80,
      key: "city",
      colSort: 2,
      hideInList: false,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },

    {
      name: "总数",
      width: 80,
      key: "totalCount",
      type: ColType.NUMBER,
      defaultSortOrder: "descend",
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "", record.type, -1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "0星",
      width: 80,
      key: "star0",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "", record.type, 0);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "1星",
      width: 80,
      key: "star1",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "", record.type, 1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "2星",
      width: 80,
      key: "star2",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "", record.type, 2);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "3星",
      width: 80,
      key: "star3",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "", record.type, 3);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "4星",
      width: 80,
      key: "star4",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "", record.type, 4);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },

    {
      name: "5星",
      width: 80,
      key: "star5",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "", record.type, 5);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "我的客户数",
      width: 150,
      key: "newCount",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "NEW", record.type, -1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "再分配客户数",
      width: 150,
      key: "myCount",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "MY", record.type, -1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "重要客户数",
      width: 150,
      key: "favCount",
      type: ColType.NUMBER,
      defaultSortOrder: false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.id, "FAV", record.type, -1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
      
    },
    {
      name: "销售",
      key: "saleIds",
      colSort: 3,
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.TREE_MUL,
      getOptions: () => {
        if(role == "op_manager" || role == "monitor"){
          return apiClient.getTeamMemberTreeAsOpts("root");
        }else{
          return apiClient.getTeamMemberTreeAsOpts(username);
        }
      }
    },

    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },

    {
      name: "日期",
      key: "createdAt",
      hideInList: true,
      showInFilter: false,
      type: ColType.DATE_RANGE,
    },
    
  ];

  let nowDate = new Date();
  let nowDateStr = formatDate(nowDate);
  const city = localStorage.getItem("city");
  const [initFilterValues, setInitFilterValues] = useState({
    createdAt: [nowDate, nowDate],
    city:city,
  });

  const initParams = {
    createdAt: nowDateStr + "," + nowDateStr,
    city:city,
  };

  const openLeadItemModalUser = async (
    id: number,
    leadType: string,
    type: string,
    star: number
  ) => {
    let queryParams = crudApiUser?.getQueryParams();
    let userId = null;
    let teamId = null;
    if (type == "org") {
      teamId = id;
    } else {
      userId = id;
    }
    let p: LeadReportItemProps = {
      reportType: "StatOwnerVisit",
      leadType: leadType,
      ...queryParams,
      teamId: teamId,
      userId: userId,
      star: star,
    };
    setLeadReportItemPropsUser(p);
    setShowLeadItemModalUser(true);
  };

  return (
    <>
      <Tabs type="line" style={{ margin: 10 }}>
        <TabPane
          tab={
            <span>
              <IconUser />
              用户维度
            </span>
          }
          itemKey="2"
        >
          <Modal
            fullScreen
            title="客户列表"
            visible={showLeadItemModalUser}
            hasCancel={false}
            onCancel={() => setShowLeadItemModalUser(false)}
            okType="tertiary"
            okText="关闭"
            onOk={() => setShowLeadItemModalUser(false)}
            contentStyle={{ overflow: 'auto' }}
            bodyStyle={{
              height: '100%',
              padding: 0,
              overflow: 'hidden' // 父级隐藏滚动条，由内容自己管理
            }}
          >
            <LeadReportItem
              reportType={leadReportItemPropsUser?.reportType}
              leadType={leadReportItemPropsUser?.leadType}
              createdAt={leadReportItemPropsUser?.createdAt}
              teamId={leadReportItemPropsUser?.teamId}
              city={leadReportItemPropsUser?.city}
              star={leadReportItemPropsUser?.star}
              userId={leadReportItemPropsUser?.userId}
              saleIds={leadReportItemPropsUser?.saleIds}
            ></LeadReportItem>
          </Modal>
          <Crud
            getCrudApi={(crudApi) => {
              setCrudApiUser(crudApi);
            }}
            name="数据跟进报表"
            canExport={true}
            entityKey="statOrgUserStar/byUser"
            pageSize={500}
            rowActionWidth={0}
            cols={colsUser}
          />
        </TabPane>
      </Tabs>
    </>
  );
}
